import { getItem } from "owa-local-storage";
import { activeSupportTicketKey } from "../constants";

export function isSupportTicketActive(targetWindow: Window): boolean {
    return getItem(targetWindow, activeSupportTicketKey) === "true";
}
